window.addEventListener('DOMContentLoaded', () => {
  const slider = document.querySelectorAll('.slider');
  const slide = document.querySelectorAll('.slide');

  if(slider.length == 0 || slide.length == 0) {
    return false
  } else {
    Array.from(slide).forEach(value => {
      const obj = value.querySelector("img");
      const img = new Image();
      img.src = obj.src;
      const result = img.width;

      if(result == 0) {
        value.remove()
      }
    })

    const opt = {
      wrapAround: true,
      pageDots: false,
      autoPlay: true,
      pauseAutoPlayOnHover: false,
    }

    Array.from(slider).forEach(value => {
      const item = value
      var flkty = new Flickity(item, opt)
      flkty.on( 'settle', function() {flkty.playPlayer()});
    })
  }
})